import { classNames } from 'libs/react';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { Modal } from 'components/modal/Modal';
import { PresentStack } from 'components/util/PresentStack';
import { React } from 'libs/react';
import './ModalStack.scss';
/**
 * @component ModalStack
 * @since 1.0.0
 */
export function ModalStack(props) {
    const { style, presentClassName, dismissClassName, duration } = Object.assign({ style: 'normal', presentClassName: 'modal--present', dismissClassName: 'modal--dismiss', duration: 750 }, props);
    const presenter = useRef(null);
    const [length, setLength] = useState(0);
    const [presenting, setPresenting] = useState(false);
    const [dismissing, setDismissing] = useState(false);
    const onDismissRef = useRef();
    /**
     * @method onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        const callback = onDismissRef.current;
        dismiss();
        if (callback) {
            callback();
        }
    }
    /**
     * @method present
     * @since 1.0.0
     * @hidden
     */
    function present(options) {
        const stack = presenter.current;
        if (stack == null) {
            return;
        }
        options = Object.assign({ style: 'normal' }, options);
        onDismissRef.current = options.onDismiss;
        stack.present(React.createElement(Modal, { first: length == 0, style: options.style, title: options.title, picto: options.picto, className: options.className, onClose: onClose }, options.modal));
        setLength((length) => length + 1);
        setPresenting(true);
        setDismissing(false);
    }
    /**
     * @method dismiss
     * @since 1.0.0
     * @hidden
     */
    function dismiss() {
        const stack = presenter.current;
        if (stack == null) {
            return;
        }
        onDismissRef.current = undefined;
        stack.dismiss();
        setLength((length) => (length - 1 > -1 ? length - 1 : 0));
        setPresenting(false);
        setDismissing(true);
    }
    const context = {
        present,
        dismiss
    };
    const className = classNames('modal-stack', 'modal-stack--' + style, { 'modal-stack--is-active': length }, { 'modal-stack--is-unused': length == 0 }, { 'modal-stack--is-presenting': presenting }, { 'modal-stack--is-dismissing': dismissing }, props.className);
    return (React.createElement(ModalStackContext.Provider, { value: context },
        props.children,
        React.createElement("div", { className: className, onClick: (e) => {
                if (e.target.classList[0] === 'modal') {
                    onClose();
                }
            } },
            React.createElement(PresentStack, { ref: presenter, duration: duration, presentClassName: presentClassName, dismissClassName: dismissClassName }))));
}
/**
 * @component ModalStackContext
 * @since 1.0.0
 */
export const ModalStackContext = createContext({
    present() { },
    dismiss() { }
});
/**
 * @component useModal
 * @since 1.0.0
 */
export function useModal() {
    return useContext(ModalStackContext);
}
